module.exports = __webpack_public_path__ + "static/img/center_img4.2e9a7215.png";